import keycode from "keycode";
import scrollLock from "./scroll-lock";
import {MODAL_FADE_IN_TIMEOUT} from "@main/constants";

export class Modal {

    constructor(el) {
        this.el = el;
        this.type = this.el.dataset.modal;
        this.closeBtn = this.el.querySelectorAll(".js-modal-close");
        this.htmlNode = document.querySelector("html");
        this.timer = null;
        this.initEvents();
    }

    initEvents() {
        document.addEventListener("click", (e) => {
            if (e.target.closest(`.js-modal-open[data-modal="${this.type}"]`)) {
                e.preventDefault();
                this.openModal();
            } else if (
                e.target.classList.contains("js-modal-close-wrap")
                ||
                (
                    !e.target.closest(".js-modal")
                    && !e.target.classList.contains("js-modal-open")
                    && !e.target.classList.contains("js-form-submit")
                    && !e.target.closest(".js-modal-open")
                )
            ) {
                this.closeModal();
            }
        });

        this.closeBtn.forEach((btn) => {
            btn.addEventListener("click", () => {
                this.closeModal();
            });
        });

        document.addEventListener("keyup", (e) => {
            if(e.keyCode == keycode("Escape")) {
                this.closeModal();
            }
        });

        this.el.addEventListener("openModal", () => {
            this.openModal();
            /*
            * document.querySelector(`.js-modal[data-modal="test-modal"]`).dispatchEvent(new CustomEvent("openModal"));
            * */
        });

        this.el.addEventListener("closeModal", () => {
            this.closeModal();
        });
    }

    openModal() {
        if (this.el.classList.contains("opened")) {
            return;
        }
        document.querySelectorAll(".js-modal").forEach(elem => {
            if (elem.classList.contains("opened") && elem !== this.el) {
                elem.dispatchEvent(new CustomEvent("closeModal"));
            }
        });
        this.startFadeIn(this.el);
        this.htmlNode.classList.add("modal-opened");
        scrollLock.enable();

        this.endFadeIn(this.el);
    }

    startFadeIn(el) {
        el.classList.add("fade-in");
        el.classList.remove("fade-out");
        el.style.opacity = 1;
        el.style.visibility = "visible";
        el.style.pointerEvents = "auto";
    }

    endFadeIn(el) {
        setTimeout(() => {
            el.classList.remove("fade-in");
            el.classList.add("opened");
        },MODAL_FADE_IN_TIMEOUT);
    }

    closeModal() {
        if (!this.el.classList.contains("opened")) {
            return;
        }
        this.startFadeOut(this.el);
        this.htmlNode.classList.remove("modal-opened");
        scrollLock.disable();

        this.endFadeOut(this.el);
    }

    startFadeOut(el) {
        el.classList.remove("fade-in");
        el.classList.add("fade-out");
    }

    endFadeOut(el) {
        setTimeout(() => {
            el.classList.remove("fade-out");
            el.classList.remove("opened");
            el.style.opacity = 0;
            el.style.visibility = "collapse";
            el.style.pointerEvents = "none";
        },250);
    }
}

document.querySelectorAll(".js-modal").forEach(elem => new Modal(elem));
